export default __webpack_public_path__ + "static/media/bg.c2aa9fa6.jpg";